import { ButtonPrimary } from '../../../../../../../../../baseComponents/Button'
import { ComponentWithPermissions } from '../../../../../../../../../baseComponents/CreateRoutering/types'
import PermissionChecker from '../../../../../../../../../baseComponents/PermissionChecker'
import TwinTrans from '../../../../../../../../../baseComponents/TwinTrans'
import useEditDeleteModal from '../../../../../../../../../utils/hooks/useEditDeleteModal'
import usePdfSingleModuleData from '../../../usePdfSingleModuleData'
import { PdfConfigTemplateTabProps } from '../../types'
import CPTCEModal from './CPTCEModal'
import CPTDeleteModal from './CPTDeleteModal'
import CPTListingElement from './CPTListingElement'

type CPTSectionEditProps = PdfConfigTemplateTabProps & ComponentWithPermissions & {
    sectionKey: number
}

const CPTSectionEdit: React.FC<CPTSectionEditProps> = ({config, userPermissions,  sectionKey, ...rest}) => {
    const { openModal, setOpenModal } = useEditDeleteModal()
    const { singleModuleData } = usePdfSingleModuleData()

    const renderThis: JSX.Element[] = []
    if (String(sectionKey).includes(',')) {
        const splitKey = String(sectionKey).split(',')
        const myPageKey = splitKey[0]
        const mySectionKey = splitKey[1]
        const sectionElements = config.pages[parseInt(myPageKey)].sections[parseInt(mySectionKey)].elements
        for (const key in sectionElements) {
            const element = sectionElements[key]
            renderThis.push(<CPTListingElement icon={singleModuleData[element.component].icon} text={singleModuleData[element.component].text} onEdit={() => setOpenModal({ type: 'edit', allRowData: { ...element, subKey: parseInt(key) } })} onDelete={() => setOpenModal({ type: 'delete', allRowData: { ...element, subKey: parseInt(key) } })} key={element.id} elementKey={sectionKey + ',' + key} setConfig={rest.setConfig}/>)
        }
    }
    return (
        <div className='flex flex-col h-full'>
            <div className='flex gap-15 flex-col'>
                {renderThis}
            </div>
            <PermissionChecker permission='create' userPermissions={userPermissions}>
                <ButtonPrimary className='mt-auto' onClick={() => setOpenModal({type: 'create', allRowData: {}})}>
                    <TwinTrans transKey='addElement'>Añadir elemento</TwinTrans>
                </ButtonPrimary>
            </PermissionChecker>
            {openModal && (openModal.type === 'create' || openModal.type === 'edit') ? <CPTCEModal {...{ ...rest, config, sectionKey, openModal, setOpenModal, modifyKey: sectionKey , userPermissions}} /> : null }
            {openModal?.type === 'delete' ? <CPTDeleteModal {...{ ...rest, config, openModal, sectionKey, setOpenModal, removeIn: sectionKey , userPermissions}} /> : null }
        </div>
    )
}





export default CPTSectionEdit